import {useState} from 'react'
import {Plus} from 'lucide-react'
import type {HistoryRecord} from '../../history/data/mockHistory'
import {getStatusStage, STATUS_COLUMNS} from '../data/statusBoard'
import {STAGE_ICONS} from './StatusBadges'
import StatusRecordCard from './StatusRecordCard'

type Props = {records: HistoryRecord[]; stage: string; loading: boolean; refreshing: boolean; onOpen: (id: string) => void}

export default function StatusKanbanView({records, stage, loading, refreshing, onOpen}: Props) {
  const [visibleCounts, setVisibleCounts] = useState<Record<string, number>>({})
  const columns = STATUS_COLUMNS.filter((column) => (!stage || column.id === stage) &&
    (column.id !== 'unknown' || records.some((record) => getStatusStage(record) === 'unknown')))
  return (
    <div className='bs-board' role='region' aria-label='Kanban de status das promoções' aria-busy={refreshing} tabIndex={0}>
      {columns.map((column) => {
        const items = records.filter((record) => getStatusStage(record) === column.id)
        const count = visibleCounts[column.id] || 20
        const Icon = STAGE_ICONS[column.id]
        return (
          <section className={`bs-column bs-tone--${column.tone}`} key={column.id} aria-labelledby={`bs-column-${column.id}`}>
            <div className='bs-column-heading'>
              <div className='bs-column-title'><span className='bs-column-icon'><Icon size={17} aria-hidden='true' /></span>
                <h2 id={`bs-column-${column.id}`}>{column.title} <span className='bs-column-count'>{items.length}</span></h2></div>
              <p>{column.description}</p>
              <div className='bs-column-progress' aria-hidden='true'><span style={{width: `${records.length ? items.length / records.length * 100 : 0}%`}} /></div>
            </div>
            <div className='bs-column-cards'>
              {loading ? <><div className='bs-skeleton' /><div className='bs-skeleton' /></> :
                items.slice(0, count).map((record) => <StatusRecordCard key={record.id} record={record} onOpen={() => onOpen(record.id)} />)}
              {!loading && !items.length && <div className='bs-column-empty'><Icon size={23} aria-hidden='true' /><p>Nenhuma promoção nesta etapa</p></div>}
              {items.length > count && <button type='button' className='bs-button bs-load-more' aria-label={`Carregar mais: ${column.title}`}
                onClick={() => setVisibleCounts((previous) => ({...previous, [column.id]: count + 20}))}>
                <Plus size={15} aria-hidden='true' />Ver mais ({items.length - count})
              </button>}
            </div>
          </section>
        )
      })}
    </div>
  )
}
